import { Adjustment, ReturnableItem } from "@redotech/redo-model/return-flow";
import { createContext, useState } from "react";

export type AvailableReturnOptions = {
  shopNow?: {
    totalAmount: number;
    totalPriceAdjustment: number;
    covered: boolean;
    adjustmentOverride?: Adjustment;
    manualReviewOverride?: boolean;
    manualReviewReason?: string;
  };
  storeCredit?: {
    totalAmount: number;
    // If not all items can be returned for store credit
    totalRefundAmount?: number;
    // Includes price adjustment from store credit and refund
    //  (if totalRefundamount is set for this option)
    totalPriceAdjustment: number;
    covered: boolean;
    adjustmentOverride?: Adjustment;
    manualReviewOverride?: boolean;
    manualReviewReason?: string;
  };
  refund?: {
    totalAmount: number;
    // If not all items can be returned for a refund
    totalStoreCreditAmount?: number;
    // Includes price adjustment from refund and store credit
    //  (if totalStoreCreditAmount is set for this option)
    totalPriceAdjustment: number;
    covered: boolean;
    instantEnabled: boolean;
    adjustmentOverride?: Adjustment;
    manualReviewOverride?: boolean;
    manualReviewReason?: string;
  };
};

const ItemsReadyForReturnContext = createContext({
  itemsReadyForReturn: [] as ReturnableItem[],
  setItemsReadyForReturn: (itemsReadyForReturn: ReturnableItem[]) => {},
  availableReturnOptions: {} as AvailableReturnOptions,
  setAvailableReturnOptions: (
    availableReturnOptions: AvailableReturnOptions,
  ) => {},
});

const ItemsReadyForReturnContextProvider = ({ children }) => {
  const [itemsReadyForReturn, setItemsReadyForReturn] = useState<
    ReturnableItem[]
  >([]);
  const [availableReturnOptions, setAvailableReturnOptions] =
    useState<AvailableReturnOptions>({});

  return (
    <ItemsReadyForReturnContext.Provider
      value={{
        itemsReadyForReturn,
        setItemsReadyForReturn,
        availableReturnOptions,
        setAvailableReturnOptions,
      }}
    >
      {children}
    </ItemsReadyForReturnContext.Provider>
  );
};

export { ItemsReadyForReturnContext, ItemsReadyForReturnContextProvider };
